import { z } from "zod"

export const valorizationTypeValues = [
  'cruce', 'descarga', 'estadia', 'flete', 'demora', 'gastos_frontera',
] as const

export type ValorizationType = typeof valorizationTypeValues[number]

export const presignShipmentValorizationSchema = z.object({
  fileName: z.string().min(1).max(200),
  mimeType: z.string().min(1).max(100),
})

export const createShipmentValorizationSchema = z.object({
  type:     z.enum(valorizationTypeValues),
  quantity: z.coerce.number().positive(),
  value:    z.coerce.number().nonnegative(),
  fileKey:  z.string().min(1).optional().nullable(),
  mimeType: z.string().max(100).optional().nullable(),
  notes:    z.string().max(2000).optional().nullable(),
  driverId: z.string().uuid().optional().nullable(),
})

export const updateShipmentValorizationSchema = createShipmentValorizationSchema.partial()

export type PresignShipmentValorizationInput = z.infer<typeof presignShipmentValorizationSchema>
export type CreateShipmentValorizationInput  = z.infer<typeof createShipmentValorizationSchema>
export type UpdateShipmentValorizationInput  = z.infer<typeof updateShipmentValorizationSchema>
